import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';


const VenueBalancesFilter = props => {
    const {
        state,
        setState,
        handleSubmit,
    } = props;

    const updateState = (value, name) => {
        const data = {
            ...state,
            [name]: value,
        };
        setState(data);
    }
    const handleChange = name => event => {
        let value = event.target.value;
        updateState(value, name);
    }

    const nowYear = new Date().getFullYear() + 1;
    const years = Array.from({length: 11}, (x,i) => i+(nowYear-10));
    const venues = ['Guild', 'Eglinton Grand'];

    return (
        <Grid container spacing={2} direction="row" justify="flex-start" alignItems="center">
            {state.year !== undefined && (
                <Grid item>
                    <TextField
                        style={{width: 100}}
                        select
                        id="year"
                        label="Year"
                        value={state.year}
                        onChange={handleChange('year')}
                        margin="dense"
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {years.map((option, i) => (
                            <MenuItem key={i} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}
            {state.venue !== undefined && (
                <Grid item>
                    <TextField
                        style={{width: 140}}
                        select
                        id="venue"
                        label="Venue"
                        value={state.venue}
                        onChange={handleChange('venue')}
                        margin="dense"
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {venues.map((option, i) => (
                            <MenuItem key={i} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}
            <Grid item>
                <Button variant="outlined" color="primary" size="medium" onClick={handleSubmit}>Submit</Button>
            </Grid>
        </Grid>
    )
}

export default VenueBalancesFilter;
